export enum TYPES {
    Configurations = "configurations",
    FirmwareVersions = "firmware versions"
}
